import { render, staticRenderFns } from "./update-paste.vue?vue&type=template&id=27571ac3&"
import script from "./update-paste.vue?vue&type=script&lang=js&"
export * from "./update-paste.vue?vue&type=script&lang=js&"
import style0 from "./update-paste.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports